export default "__VITE_ASSET__ad52da0c__"